'use client';

import IconTriangleArrowBottom from '@dealroadshow/uikit-icon/IconTriangleArrowBottom';
import { supports } from './supports';
import styles from './styles.module.scss';

const SupportInfo = () => {
  return (
    <div className={ styles.wrapper }>
      <div className={ styles.listWrapper }>
        { supports.map(({ key, icon: Icon, title, description }) => (
          <div className={ styles.item } key={ key }>
            <div className={ styles.content }>
              <div className={ styles.icon }>
                <Icon />
              </div>
              <div className={ styles.title }>
                { title }
              </div>
              <div className={ styles.description }>
                { description }
              </div>
              <IconTriangleArrowBottom className={ styles.arrow } />
            </div>
            <div className={ styles.dots } />
          </div>
        )) }
      </div>
      <div className={ styles.line } />
    </div>
  );
};

export default SupportInfo;
